export enum SignUpBenefitMode {
  WELCOME = 'welcome',
  ALERT = 'alert',
  NONE = 'none',
}

export const SignUpBenefitModalFlagKey = 's_b_key';
